var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.items),function(item,i){return _c('db-chip',{key:i,attrs:{"item":item},on:{"click":function($event){return _vm.$emit('click', item)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }